// @flow
import { ListItem } from 'material-ui/List';
import { Tooltip } from '@material-ui/core';
import React from 'react';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import moment from 'moment';
import InfoIcon from 'material-ui/svg-icons/action/info';

import { Numeric } from 'common/components/Number';
import DateRange from 'common/domain/DateRange';
import * as TimeResolution from 'statsradio/modules/metrics/domain/TimeResolution';
import HistoryEntry from '../domain/HistoryEntry';

const ListItemWrapper = styled.div`
  font-weight: normal;
  white-space: nowrap;

  ${({ selected, theme }) => selected && `
    font-weight: ${theme.fonts.weights.bold};
  `}
`;

const NumericWrapper = styled(Numeric)`
  font-size: 20px;
  margin-top: 3px;
`;

const ReachWrapper = styled(NumericWrapper)`
  color: ${({ theme }) => (theme.colors.reach)};
  margin-left: ${({ theme }) => theme.metrics.tinyMargin}px;
  width: 120px;
`;

const ListeningTimeWrapper = styled(NumericWrapper)`
  color: ${({ theme }) => (theme.colors.listeningTime)};
`;

const WeekWrapper = styled.div`
  display: flex;
  align-items: center;

  font-size: 13px;
`;

const MetricWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: ${({ theme }) => theme.metrics.tinyMargin}px;
`;

const InterpolatedWeekWrapper = styled.div`
  position: relative;
`;

const InterpolatedIcon = styled(InfoIcon)`
  float: right;
  margin: ${({ theme }) => theme.metrics.smallMargin}px;
`;

export const INTERPOLATION_ICON_ID = 'history-list-week-interpolation-icon';
export const INTERPOLATION_TOOLTIP_ID = 'history-list-week-interpolation-tooltip';

type InterpolatedWeekProps = {
  interpolated: boolean,
  theme: any,
  t: any,
  children: any,
}

export function InterpolatedWeek({ interpolated, theme, t, children }: InterpolatedWeekProps) {
  if (!interpolated) {
    return <React.Fragment>{children}</React.Fragment>;
  }

  return (
    <Tooltip disableFocusListener disableTouchListener title={t('interpolated')} id={INTERPOLATION_TOOLTIP_ID}>
      <InterpolatedWeekWrapper>
        <InterpolatedIcon style={{ color: theme.colors.message.important.color }} size={{ height: 16 }} id={INTERPOLATION_ICON_ID} />
        {children}
      </InterpolatedWeekWrapper>
    </Tooltip>
  );
}

type Props = {
  week: HistoryEntry,
  selectedDate: moment,

  t: any,
  theme: any,
}

export function HistoryListWeek(props: Props) {
  const { t, theme, week, selectedDate } = props;
  const dateRange = new DateRange({ from: week.from, to: week.to });
  const weekFormatted = t('weekDateRange', { from: week.from, to: week.to });

  const { interpolated } = week;
  const listeningTime = TimeResolution.convertSeconds(week.listeningTime, 'HOURS');

  return (
    <InterpolatedWeek interpolated={interpolated} t={t} theme={theme}>
      <ListItemWrapper selected={selectedDate && dateRange.contains(selectedDate)}>
        <ListItem key={weekFormatted}>
          <WeekWrapper>{weekFormatted}</WeekWrapper>
          <MetricWrapper>
            <ReachWrapper value={week.reach} roundAt={0} />
            <ListeningTimeWrapper value={listeningTime} roundAt={0} suffix={t('time.hours').toLowerCase()} />
          </MetricWrapper>
        </ListItem>
      </ListItemWrapper>
    </InterpolatedWeek>
  );
}
export default translate('history')(withTheme(HistoryListWeek));



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryListWeek.js